import React from "react";
import SummaryCard from "./SummaryCard";
import { getComplianceNameById } from "./summaryHelpers";
import { SetBacksInspectionInput } from "../SetBacksInspectionForm.types";
import { ComplianceData } from "../SetBacksInspectionForm.types";

type Props = {
    data?: SetBacksInspectionInput;
    complianceData?: ComplianceData[];
};

const SetBacksReadOnly: React.FC<Props> = ({ data, complianceData }) => {
    if (!data) return null;
    return (
        <SummaryCard
            title={
                <>
                    <svg className="me-2" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 3h-8v4h8V3z"/></svg>
                    Setbacks
                </>
            }
        >
            <div className="row mb-3">
                <div className="col col-md-3">
                    <label>{getComplianceNameById(complianceData as any, (data as any)?.surfaceWaterComplianceId)}</label>
                </div>
                <div className="col col-md-9">
                    <label>Surface Water</label>
                    {data?.surfaceWater && (
                        <div className="mt-1">
                            <span className="print-value fw-bold">{data?.surfaceWater} ft</span>
                        </div>
                    )}
                </div>
            </div>
            {(data as any)?.surfaceWaterCompliance?.complianceValue === "Out of Compliance" ? (
                <div className="row mb-3">
                    <div className="col col-md-12">
                        <label>Surface Water Comment</label>
                        <div className="mt-1">
                            <span className="print-value fw-bold">{data?.surfaceWaterComment}</span>
                        </div>
                    </div>
                </div>
            ) : null}

            <div className="row mb-3">
                <div className="col col-md-3">
                    <label>{getComplianceNameById(complianceData as any, (data as any)?.ditchesComplianceId)}</label>
                </div>
                <div className="col col-md-9">
                    <label>Ditches</label>
                    {data?.ditches && (
                        <div className="mt-1">
                            <span className="print-value fw-bold">{data?.ditches} ft</span>
                        </div>
                    )}
                </div>
            </div>
            {(data as any)?.ditchesCompliance?.complianceValue === "Out of Compliance" ? (
                <div className="row mb-3">
                    <div className="col col-md-12">
                        <label>Ditches Comment</label>
                        <div className="mt-1">
                            <span className="print-value fw-bold">{data?.ditchesComment}</span>
                        </div>
                    </div>
                </div>
            ) : null}

            <div className="row mb-3">
                <div className="col col-md-3">
                    <label>{getComplianceNameById(complianceData as any, (data as any)?.privateWellsComplianceId)}</label>
                </div>
                <div className="col col-md-9">
                    <label>Private Wells</label>
                    {data?.privateWells && (
                        <div className="mt-1">
                            <span className="print-value fw-bold">{data?.privateWells} ft</span>
                        </div>
                    )}
                </div>
            </div>
            {(data as any)?.privateWellsCompliance?.complianceValue === "Out of Compliance" ? (
                <div className="row mb-3">
                    <div className="col col-md-12">
                        <label>Private Wells Comment</label>
                        <div className="mt-1">
                            <span className="print-value fw-bold">{data?.privateWellsComment}</span>
                        </div>
                    </div>
                </div>
            ) : null}

            <div className="row mb-3">
                <div className="col col-md-3">
                    <label>{getComplianceNameById(complianceData as any, (data as any)?.publicWellsComplianceId)}</label>
                </div>
                <div className="col col-md-9">
                    <div className="row">
                        <div className="col col-md-6">
                            <label>Public Wells &gt;2000 gpd</label>
                            {data?.publicWellsOver2000Gpd !== undefined && data?.publicWellsOver2000Gpd !== null && (
                                <div className="mt-1">
                                    <span className="print-value fw-bold">{data?.publicWellsOver2000Gpd} ft</span>
                                </div>
                            )}
                        </div>
                        <div className="col col-md-6">
                            <label>Public Wells ≤2000 gpd</label>
                            {data?.publicWellsUnder2000Gpd !== undefined && data?.publicWellsUnder2000Gpd !== null && (
                                <div className="mt-1">
                                    <span className="print-value fw-bold">{data?.publicWellsUnder2000Gpd} ft</span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {(data as any)?.publicWellsCompliance?.complianceValue === "Out of Compliance" ? (
                <div className="row mb-3">
                    <div className="col col-md-12">
                        <label>Public Wells Comment</label>
                        <div className="mt-1">
                            <span className="print-value fw-bold">{data?.publicWellsComment}</span>
                        </div>
                    </div>
                </div>
            ) : null}

            <div className="row mb-3">
                <div className="col col-md-3">
                    <label>{getComplianceNameById(complianceData as any, (data as any)?.irrigationWellsComplianceId)}</label>
                </div>
                <div className="col col-md-9">
                    <label>Irrigation Wells</label>
                    {data?.irrigationWells && (
                        <div className="mt-1">
                            <span className="print-value fw-bold">{data?.irrigationWells} ft</span>
                        </div>
                    )}
                </div>
            </div>
            {(data as any)?.irrigationWellsCompliance?.complianceValue === "Out of Compliance" ? (
                <div className="row mb-3">
                    <div className="col col-md-12">
                        <label>Irrigation Wells Comment</label>
                        <div className="mt-1">
                            <span className="print-value fw-bold">{data?.irrigationWellsComment}</span>
                        </div>
                    </div>
                </div>
            ) : null}

            <div className="row mb-3">
                <div className="col col-md-3">
                    <label>{getComplianceNameById(complianceData as any, (data as any)?.portableWaterLinesComplianceId)}</label>
                </div>
                <div className="col col-md-9">
                    <div className="row">
                        <div className="col col-md-4">
                            <label>Potable Water Lines</label>
                            {data?.portableWaterLines && (
                                <div className="mt-1">
                                    <span className="print-value fw-bold">{data?.portableWaterLines} ft</span>
                                </div>
                            )}
                        </div>
                        <div className="col col-md-4">
                            <label>Sleeved</label>
                            {(data?.potableWaterLinesSleeved !== undefined && data?.potableWaterLinesSleeved !== null) && (
                                <div className="mt-1">
                                    <span className="print-value fw-bold">{data?.potableWaterLinesSleeved ? "Yes" : "No"}</span>
                                </div>
                            )}
                        </div>
                        <div className="col col-md-4">
                            <label>Schedule 40 PVC</label>
                            {(data?.potableWaterLinesSchedule40Pvc !== undefined && data?.potableWaterLinesSchedule40Pvc !== null) && (
                                <div className="mt-1">
                                    <span className="print-value fw-bold">{data?.potableWaterLinesSchedule40Pvc ? "Yes" : "No"}</span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {(data as any)?.portableWaterLinesCompliance?.complianceValue === "Out of Compliance" ? (
                <div className="row mb-3">
                    <div className="col col-md-12">
                        <label>Potable Water Lines Comment</label>
                        <div className="mt-1">
                            <span className="print-value fw-bold">{data?.portableWaterLinesComment}</span>
                        </div>
                    </div>
                </div>
            ) : null}

            <div className="row mb-3">
                <div className="col col-md-3">
                    <label>{getComplianceNameById(complianceData as any, (data as any)?.buildingFoundationComplianceId)}</label>
                </div>
                <div className="col col-md-9">
                    <label>Building Foundation</label>
                    {data?.buildingFoundation && (
                        <div className="mt-1">
                            <span className="print-value fw-bold">{data?.buildingFoundation} ft</span>
                        </div>
                    )}
                </div>
            </div>
            {(data as any)?.buildingFoundationCompliance?.complianceValue === "Out of Compliance" ? (
                <div className="row mb-3">
                    <div className="col col-md-12">
                        <label>Building Foundation Comment</label>
                        <div className="mt-1">
                            <span className="print-value fw-bold">{data?.buildingFoundationComment}</span>
                        </div>
                    </div>
                </div>
            ) : null}

            <div className="row mb-3">
                <div className="col col-md-3">
                    <label>{getComplianceNameById(complianceData as any, (data as any)?.propertyLinesComplianceId)}</label>
                </div>
                <div className="col col-md-9">
                    <label>Property Lines</label>
                    {data?.propertyLines && (
                        <div className="mt-1">
                            <span className="print-value fw-bold">{data?.propertyLines} ft</span>
                        </div>
                    )}
                </div>
            </div>
            {(data as any)?.propertyLinesCompliance?.complianceValue === "Out of Compliance" ? (
                <div className="row mb-3">
                    <div className="col col-md-12">
                        <label>Property Lines Comment</label>
                        <div className="mt-1">
                            <span className="print-value fw-bold">{data?.propertyLinesComment}</span>
                        </div>
                    </div>
                </div>
            ) : null}

            <div className="row mb-3">
                <div className="col col-md-3">
                    <label>{getComplianceNameById(complianceData as any, (data as any)?.otherComplianceId)}</label>
                </div>
                <div className="col col-md-9">
                    <div className="row">
                        <div className="col col-md-6">
                            <label>Other</label>
                            {data?.otherSetback && (
                                <div className="mt-1">
                                    <span className="print-value fw-bold">{data?.otherSetback} ft</span>
                                </div>
                            )}
                        </div>
                        <div className="col col-md-6">
                            <label>Description</label>
                            {data?.otherComment && (
                                <div className="mt-1">
                                    <span className="print-value fw-bold">{data?.otherComment}</span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </SummaryCard>
    );
};

export default SetBacksReadOnly;



